var UISteps = (function ($) {

    UISteps = function () {
        var that = this;

        // CONST
        that.class = {
            is_current: 'current'
        };

        // INIT
        that.updateStepVisibility();

        $.sa.$window.on('resize', function () {
            that.updateStepVisibility();
        });
    };

    UISteps.prototype.updateStepVisibility = function () {
        var that = this;

        /*
        * Проверяем ширину экрана.
        * Проверяем ширину блока.
        * 
        * Если ширина блока больше ширины экрана, включаем скрипт.
        * 
        * Определяем оффсет активного шага.
        * Двигаем step-wrapper на ширину оффсета активного шага + половину его ширины 
        * 
        **/

        var $body = $.sa.$document.find('body'),
            $page_width = $body.outerWidth();

        $body.find('.js-steps').each(function () {
            var $steps = $(this),
                $steps_wrapper = $steps.find('.js-steps-wrapper'),
                $page_container = $steps.parents('.page-container'),
                $step_current = $steps.find('.' + that.class.is_current),
                steps_width = $steps_wrapper[0].scrollWidth;

            if ($page_container.length) {
                $page_width = $page_container.outerWidth();
            }

            if (steps_width <= $page_width) {
                return true;
            }

            var previous_steps = $step_current.prev();
            if (previous_steps.length) {
                var previous_steps_width = 0;
                $step_current.prevAll().each(function() {
                    previous_steps_width += $(this).width();
                });
                $steps_wrapper.scrollLeft(previous_steps_width);
            } else {
                $steps_wrapper.scrollLeft(0);
            }
        });
    };

    return UISteps;
})($);